<template>
    <div>
        <div class="tabs">
            <div
                v-for="(tab, index) in tabs"
                :key="index"
                :class="{ active: activeTab === index }"
                @click="activeTab = index"
                class="tab"
            >
                {{ tab.label }}
            </div>
        </div>
        <!-- <div class="tab-content">
            <p>{{ tabs[activeTab].content }}</p>
        </div> -->
    </div>
</template>

<script>
import { defineComponent, ref } from "vue";

export default defineComponent({
    props: {
        title: {
            type: String,
            default: "",
        },
        category: {
            type: String,
            default: "",
        },
        date: {
            type: String,
            default: "",
        },
        downloadFile: {
            type: String,
            default: "",
        },
        onClick: Function,
    },
    components: {},
    setup() {
        const tabs = ref([
            {
                label: "수리 기준",
                content: "서비스요청 상담/접수 내용",
            },
            { label: "비용 안내", content: "부품가격 상담/접수 내용" },
            { label: "보증 기간", content: "재생부품 가격산정 내용" },
            {
                label: "AS 접수 방법",
                content: "서비스품질 향상/접수 내용",
            },
        ]);
        const activeTab = ref(0);
        return {
            tabs,
            activeTab,
        };
    },
});
</script>

<style scoped>
.tabs {
    display: flex;
    /* border-bottom: 1px solid #ccc; */
    padding: 0;
}
.tab {
    flex: 1;
    padding: 10px 20px;
    cursor: pointer;
    border: 1px solid #ccc;
}
.tab.active {
    border: 1px solid black;
    border-bottom: none;
}
.tab-content {
    padding: 20px;
    border: 1px solid #ccc;
}
</style>
